<template>
  <div>
    <div class="enterprise-status">
      <p class="status-title">
        <span>{{ $t('Company Overview') }}</span>
      </p>
      <!-- 企业权益 -->
      <el-row :gutter="isMobile ? 0 : 16">
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="totals">
            <div class="total">
              <p>{{ $t('Company User') }}</p>
              <span>{{ EmployeeNums }}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="totals">
            <div class="total">
              <p>{{ $t('Company UPDF Licenses') }}</p>
              <span>{{ allAuthNum.updf }}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" v-if="!isAIStandardCompany">
          <div class="totals">
            <div class="total">
              <p>{{ $t('Company AI Licenses') }}</p>
              <span>{{ allAuthNum.ai }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 授权情况 -->
      <el-row :gutter="isMobile ? 0 : 16">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <div class="authorization" :class="{ 'is-floating-company': props.isFloatingCompany }">
            <div class="authorization-name">
              <div class="type">
                <img src="@/assets/product-updf-logo.png" alt="" />
                <span>{{ $t('UPDF') }}</span>
              </div>
              <div class="btn btn-upgrade">{{ $t('Upgrade') }}</div>
            </div>
            <div class="number-container" v-if="productExpirationTimeData.updf.nextPayTime !== 0 || productExpirationTimeData.updf.expireTime !== 0">
              <p v-if="productExpirationTimeData.updf.nextPayTime"><span></span>{{ $t('Renews') }}: {{ formatTime(productExpirationTimeData.updf.nextPayTime * 1000, 'L') }}</p>
              <p v-else-if="productExpirationTimeData.updf.expireTime > 0"><span></span>{{ $t('Expiration date:') }} {{ formatTime(productExpirationTimeData.updf.expireTime * 1000, 'L') }}</p>
              <p v-else-if="productExpirationTimeData.updf.expireTime === -1"><span></span>{{ $t('Expiration date:') }} {{ $t('UPDF Lifetime') }}</p>
            </div>
            <div class="authorization-container">
              <div class="chart-left">
                <div class="chart-left-title">{{ $t('Authorization') }}</div>
                <div class="chart-left-content">
                  <el-tooltip :content="$t('Authorized employee') + ': ' + allAuthNum.authUpdf" placement="top">
                    <span class="authorized-span be-authorized" :style="`--width: ${updfAuthorizationPercentage != 0 ? 100 - updfAuthorizationPercentage : 100}%; --bgColor: rgba(160, 126, 255, 1)`"></span>
                  </el-tooltip>
                  <el-tooltip :content="$t('Unauthorized employee') + ': ' + allAuthNum.unAuthUpdf" placement="top">
                    <span
                      class="authorized-span unauthorized"
                      :class="{ noLeft: (updfAuthorizationPercentage ? updfAuthorizationPercentage : 100) === 100 || (updfAuthorizationPercentage ? updfAuthorizationPercentage : 100) === 0 }"
                      :style="`--width: ${updfAuthorizationPercentage ? updfAuthorizationPercentage : 0}%; --bgColor: rgba(224, 213, 252, 1)`"
                    ></span>
                  </el-tooltip>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(160, 126, 255, 1)"></span>
                    {{ $t('Authorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.authUpdf }}</span> / {{ allAuthNum.updf }}
                  </div>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(224, 213, 252, 1)"></span>
                    {{ $t('Unauthorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.unAuthUpdf }}</span> / {{ allAuthNum.updf }}
                  </div>
                </div>
              </div>
              <div class="chart-line"></div>
              <div class="chart-right">
                <div class="chart-right-title">{{ $t('Use Of State') }}</div>
                <div class="chart-container">
                  <ChartCanvas canvasColor="rgba(160, 126, 255, 1)" :canvasPercentage="updfAuthorizationPercentage" />
                  <div class="chart-text">
                    <span class="text">{{ $t('Residue') }}</span>
                    <br />
                    {{ allAuthNum.unAuthUpdf }} <span>/ {{ allAuthNum.updf }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="!isAIStandardCompany">
          <div class="authorization">
            <div class="authorization-name">
              <div class="type">
                <img src="@/assets/product-updf-ai-logo.png" alt="" />
                <span>{{ $t('UPDF AI Plan') }}</span>
              </div>
              <div class="btn btn-upgrade">{{ $t('Upgrade') }}</div>
            </div>
            <div class="number-container" v-if="productExpirationTimeData.ai.nextPayTime !== 0 || productExpirationTimeData.ai.expireTime !== 0">
              <p v-if="productExpirationTimeData.ai.nextPayTime"><span></span>{{ $t('Renews') }}: {{ formatTime(productExpirationTimeData.ai.nextPayTime * 1000, 'L') }}</p>
              <p v-else-if="productExpirationTimeData.ai.expireTime > 0"><span></span>{{ $t('Expiration date:') }} {{ formatTime(productExpirationTimeData.ai.expireTime * 1000, 'L') }}</p>
            </div>
            <div class="authorization-container">
              <div class="chart-left">
                <div class="chart-left-title">{{ $t('Authorization') }}</div>
                <div class="chart-left-content">
                  <el-tooltip :content="$t('Authorized employee') + ': ' + allAuthNum.authAi" placement="top">
                    <span class="authorized-span be-authorized" :style="`--width: ${aiAuthorizationPercentage != 0 ? 100 - aiAuthorizationPercentage : 100}%; --bgColor: rgba(160, 126, 255, 1)`"></span>
                  </el-tooltip>
                  <el-tooltip :content="$t('Unauthorized employee') + ': ' + allAuthNum.unAuthAi" placement="top">
                    <span
                      class="authorized-span unauthorized"
                      :class="{ noLeft: (aiAuthorizationPercentage ? aiAuthorizationPercentage : 100) === 100 || (aiAuthorizationPercentage ? aiAuthorizationPercentage : 100) === 0 }"
                      :style="`--width: ${aiAuthorizationPercentage ? aiAuthorizationPercentage : 0}%; --bgColor: rgba(224, 213, 252, 1)`"
                    ></span>
                  </el-tooltip>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(160, 126, 255, 1)"></span>
                    {{ $t('Authorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.authAi }}</span> / {{ allAuthNum.ai }}
                  </div>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(224, 213, 252, 1)"></span>
                    {{ $t('Unauthorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.unAuthAi }}</span> / {{ allAuthNum.ai }}
                  </div>
                </div>
              </div>
              <div class="chart-line"></div>
              <div class="chart-right">
                <div class="chart-right-title">{{ $t('Use Of State') }}</div>
                <div class="chart-container">
                  <ChartCanvas canvasColor="rgba(160, 126, 255, 1)" :canvasPercentage="aiAuthorizationPercentage" />
                  <div class="chart-text">
                    <span class="text">{{ $t('Residue') }}</span>
                    <br />
                    {{ allAuthNum.unAuthAi }} <span>/ {{ allAuthNum.ai }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="!isCN">
          <div class="authorization">
            <div class="authorization-name">
              <div class="type">
                <img src="@/assets/product-updf-sign-logo.png" alt="" />
                <span>{{ $t('UPDF Sign') }}</span>
              </div>
              <div v-if="signAuthPackageShow && !isCN" class="btn btn-usage" @click="signAuthPackageDialogVisible = true">{{ $t('Usage of amount') }}</div>
            </div>
            <div class="number-container" v-if="signAuthPackageShow && !isCN">
              <p><span></span>{{ $t('Total signature amount:') }} {{ signAuthPackageData.total }}</p>
              <p><span></span>{{ $t('Expiration date:') }} {{ formatTime(signAuthPackageData.expireTime * 1000, 'L') }}</p>
              <p><span></span>{{ $t('Remaining amount:') }} {{ signAuthPackageData.remainTotal }}</p>
            </div>
            <div class="number-container" v-if="!signAuthPackageShow && (productExpirationTimeData.sign.nextPayTime !== 0 || productExpirationTimeData.sign.expireTime > 0)">
              <p v-if="productExpirationTimeData.sign.nextPayTime"><span></span>{{ $t('Renews') }}: {{ formatTime(productExpirationTimeData.sign.nextPayTime * 1000, 'L') }}</p>
              <p v-else-if="productExpirationTimeData.sign.expireTime > 0"><span></span>{{ $t('Expiration date:') }} {{ formatTime(productExpirationTimeData.sign.expireTime * 1000, 'L') }}</p>
            </div>
            <div class="authorization-container">
              <div class="chart-left">
                <div class="chart-left-title">{{ $t('Authorization') }}</div>
                <div class="chart-left-content">
                  <el-tooltip :content="$t('Authorized employee') + ': ' + allAuthNum.authSign" placement="top">
                    <span class="authorized-span be-authorized" :style="`--width: ${signAuthorizationPercentage != 0 ? 100 - signAuthorizationPercentage : 100}%; --bgColor: rgba(160, 126, 255, 1)`"></span>
                  </el-tooltip>
                  <el-tooltip :content="$t('Unauthorized employee') + ': ' + allAuthNum.unAuthSign" placement="top">
                    <span
                      class="authorized-span unauthorized"
                      :class="{ noLeft: (signAuthorizationPercentage ? signAuthorizationPercentage : 100) === 100 || (signAuthorizationPercentage ? signAuthorizationPercentage : 100) === 0 }"
                      :style="`--width: ${signAuthorizationPercentage ? signAuthorizationPercentage : 0}%; --bgColor: rgba(224, 213, 252, 1)`"
                    ></span>
                  </el-tooltip>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(160, 126, 255, 1)"></span>
                    {{ $t('Authorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.authSign }}</span> / {{ allAuthNum.sign }}
                  </div>
                </div>
                <div class="chart-left-bottom">
                  <div class="chart-left-bottom-title">
                    <span style="--bgColor: rgba(224, 213, 252, 1)"></span>
                    {{ $t('Unauthorized') }}
                  </div>
                  <div class="chart-left-bottom-number">
                    <span>{{ allAuthNum.unAuthSign }}</span> / {{ allAuthNum.sign }}
                  </div>
                </div>
              </div>
              <div class="chart-line"></div>
              <div class="chart-right">
                <div class="chart-right-title">{{ $t('Use Of State') }}</div>
                <div class="chart-container">
                  <ChartCanvas canvasColor="rgba(160, 126, 255, 1)" :canvasPercentage="signAuthorizationPercentage" />
                  <div class="chart-text">
                    <span class="text">{{ $t('Residue') }}</span>
                    <br />
                    {{ allAuthNum.unAuthSign }} <span>/ {{ allAuthNum.sign }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="quick-entry">
      <div class="quick">
        <p class="quick-title">{{ $t('More Operations') }}</p>
        <el-row :gutter="isMobile ? 0 : 10">
          <el-col v-if="!isFloatingCompany" :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="showHomeDialog">
              <span><img src="@/assets/management-redeem-authorization.png" alt="" /></span>
              <p>{{ $t('Redeem-3') }}</p>
            </div>
          </el-col>
          <el-col v-if="!isFloatingCompany" :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="skip(1)">
              <span><img src="@/assets/purchase-updf.png" alt="" /></span>
              <p>{{ $t('Buy UPDF Licenses') }}</p>
            </div>
          </el-col>
          <el-col v-if="!isFloatingCompany && !isAIStandardCompany" :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="skip(1)">
              <span><img src="@/assets/purchase-ai.png" alt="" /></span>
              <p>{{ $t('Buy AI Licenses') }}</p>
            </div>
          </el-col>
          <el-col v-if="!isFloatingCompany && !signAuthPackageShow && !isCN" :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="skip(3)">
              <span><img src="@/assets/purchase-sign.png" alt="" /></span>
              <p>{{ $t('Buy Sign Licenses') }}</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="$router.push({ name: 'companyStaff' })">
              <span><img src="@/assets/management.png" alt="" /></span>
              <p>{{ $t('Member Management') }}</p>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="4">
            <div class="item" @click="$router.push({ name: 'companySettings' })">
              <span><img src="@/assets/enterprise-settings.png" alt="" /></span>
              <p>{{ $t('Company Settings') }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <RedeemDialog v-if="isShowAutoReedem" :disabled="dialogDisabled" :is-show="isShowAutoReedem" v-model:reedemCode="reedemCode" @on-close-dialog="closeDialog" @on-init-chart="initDialogChange"></RedeemDialog>
    <el-dialog v-model="signAuthPackageDialogVisible" :show-close="false" width="85%" class="signAuthPackageDialog">
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <h4 :id="titleId" :class="titleClass">{{ $t('Usage of Amount Detail') }}</h4>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="close">
            <path d="M7.13867 17.1393L17.417 6.86099" stroke="#353535" stroke-linecap="round" />
            <path d="M17.4177 17.1393L7.13943 6.86099" stroke="#353535" stroke-linecap="round" />
          </svg>
        </div>
      </template>
      <el-table ref="multipleTableRef" :data="signAutoData">
        <el-table-column property="nickName" :label="$t('Full Name')" />
        <!-- min-width=150  min-width="170"  min-width="100" -->
        <el-table-column property="account" :label="$t('Account_1')" />
        <el-table-column property="email" :label="$t('Email')" />
        <el-table-column property="phone" :label="$t('Phone Number')" />
        <el-table-column property="consumed" :label="$t('Amount Consumed')" />
        <el-table-column property="lastConsumed" min-width="110" :label="$t('Last Consumption Time')" sortable />
        <el-table-column property="auths.sign" :label="$t('UPDF Sign')" fixed="right" align="center" header-align="center">
          <template #default="scope">
            <el-switch
              :disabled="scope.row.valid === 0"
              :active-value="1"
              :inactive-value="0"
              @change="handleSwitchChange(scope.row.signAuth, scope.row.employeeId, scope.row, 25654)"
              v-model="scope.row.signAuth"
              style="--el-switch-on-color: #13ce66"
            />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background="#fff"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :total="total"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100, 500]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        class="company-pagination"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { getEmployeeCount, getPlanMembers, offsetCoupon, getCompanyAiPlanList, getSignAuthPackageQuota, getUsageAmountDetails, authMembers, getPlanExpirationTime } from '@/api/company/company'
import usePlat from '@/hook/usePlat'
import { getLocalStorage, setLocalStorage } from '@/libs/utils'
import { getCheckoutUrl } from '@/services/base'
import { computed, getCurrentInstance, onMounted, ref, shallowRef, watch } from 'vue'
import { useRouter } from 'vue-router'
import RedeemDialog from './components/redeem-dialog.vue'
import ChartCanvas from './components/chart-canvas.vue'
import { formatTime } from '@/libs/tools'
import { ElMessage } from 'element-plus'
import { appStore } from '@/stores'

const props = defineProps({
  isFloatingCompany: {
    type: Number,
    default: 0,
  },
  organizeExpiredTime: {
    type: Number,
    default: 0,
  },
})

const { $t } = getCurrentInstance().proxy

// const echartsLeft = ref(null)
const isCN = appStore.isCN
const chartL = shallowRef(null)
const chartR = shallowRef(null)
const EmployeeNums = ref(0)
const allAuthNum = ref(0) // 全部授权
const isAIStandardCompany = ref(false) // 是否为ai标准企业
// const authedEmployeeNum = ref(0)
const reedemCode = ref()
const isShowAutoReedem = ref(false)
const dialogDisabled = ref(false)
const { isMobile } = usePlat()
const signAuthPackageDialogVisible = ref(false) // 企业Sign授权包弹窗显示
const signAutoData = ref([])
const page = ref(1)
const total = ref(0)
const pageSize = ref(20)
// AI产品i对象
const aiProductIds = ref(isCN ? { unlimited: 25653, standard: 25651 } : { unlimited: 25652, standard: 25648 })
// 数字签名产品id
const signatureProductId = 25654
// UPDF产品ID
const updfProductIds = [25643, 25644, 25645, 25646, 25647]
// 各产品过期时间
const productExpirationTimeData = ref({
  updf: 0,
  ai: 0,
  sign: 0,
})
// 是否为企业Sign授权包
const signAuthPackageShow = ref(false)

// UPDF Residue百分比
const updfAuthorizationPercentage = computed(() => {
  if (!allAuthNum.value || allAuthNum.value.updf === 0) return 100
  if (allAuthNum.value.updf === 0) return 100
  return (allAuthNum.value.unAuthUpdf / allAuthNum.value.updf) * 100
})
// AI Residue百分比
const aiAuthorizationPercentage = computed(() => {
  if (!allAuthNum.value || allAuthNum.value.ai === 0) return 100
  if (allAuthNum.value.ai === 0) return 100
  return (allAuthNum.value.unAuthAi / allAuthNum.value.ai) * 100
})
// sign REsidue百分比
const signAuthorizationPercentage = computed(() => {
  if (!Number(allAuthNum.value.sign)) return 100
  if (!allAuthNum.value || allAuthNum.value.sign === 0) return 100
  if (allAuthNum.value.sign === 0) return 100
  return (allAuthNum.value.unAuthSign / allAuthNum.value.sign) * 100
})
// 获取sign授权包使用详情
const getSignAutoList = async () => {
  try {
    const res = await getUsageAmountDetails({
      page: page.value,
      pageSize: pageSize.value,
    })

    if (res.data) {
      signAutoData.value = res.data.details
      console.log(res.data.list, '----list')
      signAutoData.value.forEach(row => {
        if (row.lastConsumed === 0) {
          row.lastConsumed = ''
        } else {
          row.lastConsumed = new Date(row.lastConsumed * 1000).toLocaleString()
        }
      })
      total.value = res.data.total
    }
  } catch (error) {
    console.log(error)
  }
}
const handleCurrentChange = val => {
  page.value = val
  getSignAutoList()
}
// 授权sign
const handleSwitchChange = async (type, employeeId, row, productId) => {
  console.log(row.switchInit)
  const res = await authMembers({
    type: Number(type),
    employeeId,
    productId,
  })
  if (res.code === 200) {
    row.signAuth = Number(type)
    ElMessage({
      type: 'success',
      message: $t('Saved success'),
      showClose: true,
    })
  }
}
getSignAutoList()
// 获取所有会员过期时间
const getPlanExpirationListTime = async () => {
  try {
    const res = await getPlanExpirationTime()
    if (res.code === 200) {
      console.log(res)
      res.data.List.forEach(row => {
        if ((isCN && row.productId === aiProductIds.value.standard) || row.productId === aiProductIds.value.unlimited) {
          productExpirationTimeData.value.ai = row
        } else if (row.productId === signatureProductId) {
          productExpirationTimeData.value.sign = row
        } else if (updfProductIds.includes(row.productId)) {
          productExpirationTimeData.value.updf = row
        }
      })
    }
  } catch (error) {
    console.log(error)
  }
}
// 企业兑换码
const initReedemCode = async () => {
  if (getLocalStorage('companyReedemCode') && getLocalStorage('companyReedemCode') !== 'undefined') {
    try {
      const res = await offsetCoupon(getLocalStorage('companyReedemCode'))
      if (res.code === 200) {
        isShowAutoReedem.value = true
        dialogDisabled.value = true
        reedemCode.value = getLocalStorage('companyReedemCode')
      }
    } catch (error) {
      console.log(error)
    }
  }
}
initReedemCode()
const skip = (type = 0) => {
  // type: 默认跳转收银台 3：sign收银台
  const checkoutUrl = getCheckoutUrl('', type)
  window.open(checkoutUrl, 'blank')
}

const showHomeDialog = () => {
  dialogDisabled.value = false
  isShowAutoReedem.value = true
}
const getEmployNums = async () => {
  try {
    const res = await getEmployeeCount()
    if (res) {
      EmployeeNums.value = res.data
      if (signAuthPackageShow.value) {
        allAuthNum.value.sign = res.data
        allAuthNum.value.unAuthSign = allAuthNum.value.sign - allAuthNum.value.authSign
      }
    }
  } catch (error) {
    console.log(error)
  }
}

const closeDialog = () => {
  if (getLocalStorage('companyReedemCode')) {
    setLocalStorage('companyReedemCode', '')
  }
  isShowAutoReedem.value = false
}

const getPlanNums = async () => {
  // 如果是组织授权企业 直接表面总数量无限制
  console.log(props.isFloatingCompany, '----props.isFloatingCompany')
  console.log(props.isFloatingCompany, '----props.isFloatingCompany')
  console.log(props.organizeExpiredTime, '----props.organizeExpiredTime')

  try {
    // 获取总授权数量
    const res = await getPlanMembers()
    if (res) {
      if (props.isFloatingCompany === 2) {
        if (props.organizeExpiredTime > 0 || res.data.toString() === '9223372036854776000') {
          // allAuthNum.value = $t('Unlimited')
          allAuthNum.value = { ai: res.data.ai, updf: $t('Unlimited'), authAi: 0, authUpdf: 0, authSign: 0, unAuthAi: 0, unAuthUpdf: 0, unAuthSign: 0 }
          return
        }
        allAuthNum.value = res.data
        return
      }
      allAuthNum.value = res.data
    }
  } catch (error) {
    console.log(error)
  }
}

// 获取是否为企业标准AI用户
const getAiAuthNums = async () => {
  try {
    const res = await getCompanyAiPlanList()
    isAIStandardCompany.value = res.data.filter(item => item.productIds.length === 1 && item.productIds[0] === (isCN ? 25651 : 25648)).length >= 1
  } catch (error) {
    console.log(error)
  }
}

// 企业Sign授权包数量
const signAuthPackageData = ref({})
// 获取企业授权包数量
const getSignAuthPackageQuotaHandle = async () => {
  try {
    const res = await getSignAuthPackageQuota()
    signAuthPackageData.value = { ...res.data }
    signAuthPackageShow.value = res.data.used >= 0 && res.data.total >= 0 && res.data.remainTotal >= 0
  } catch (error) {
    console.log(error)
  }
}
// canvasHandle()
watch(
  () => props.isFloatingCompany,
  () => {
    getPlanNums()
  }
)

const initDialogChange = () => {
  getPlanNums()
  // initChart()
}
// watch(allAuthNum, () => {
//   initChart()
// })
// watch(beAuthorized, () => {
//   initChart()
// })

// watch(EmployeeNums, () => {
//   initChart()
// })
// onMounted(async () => {
//   initChart()
// })

onMounted(async () => {
  await getPlanExpirationListTime()
  await getSignAuthPackageQuotaHandle()
  await getAiAuthNums()
  await getPlanNums()
  await getEmployNums()
  window.onresize = () => {
    // alert('resi')
    // initChart()
    chartL.value && chartL.value.resize()
    chartR.value && chartR.value.resize()
  }
})

const $router = useRouter()
</script>

<style lang="scss">
.signAuthPackageDialog {
  max-width: 85%;
  .el-dialog__header {
    padding: 24px;
    .my-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .close-btn {
        cursor: pointer;
      }
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        line-height: 21.78px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
      }
    }
  }
  .el-dialog__body {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
}
.el-table {
  margin-top: 32px;
  th {
    background: #fbfbfb !important;
    &.el-table__cell {
      &.is-leaf {
        border: none;
      }
    }
  }
  th.el-table__cell {
    background: #fff !important;
  }
  .el-scrollbar__wrap {
    max-height: 50vh;
    .el-scrollbar__view {
      max-height: 50vh;
    }
  }
  .el-table__body {
    // max-height: 50vh;
    .el-table__cell {
      border-bottom: none !important;
      background: #fff;
    }
  }
}
.el-pagination {
  margin-top: 40px;
  padding-bottom: 24px !important;
  justify-content: center;
  .el-pagination__total {
    display: none;
  }

  .el-pagination__sizes {
    display: none !important;
  }
  .el-pagination__jump {
    display: none;
  }
}
.el-table__inner-wrapper {
  &::before {
    display: none;
  }
}
.ar-SA {
  .el-pagination {
    .btn-prev,
    .btn-next {
      transform: rotate(180deg);
    }
  }
}
@media screen and (max-width: 640px) {
  .signAuthPackageDialog .el-dialog__header {
    margin-right: 0;
    padding: 18px;
  }
  .el-pagination {
    .el-pagination__jump {
      &.is-last {
        display: none;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.message-class {
  font-weight: bold;
  font-size: 17px;
  line-height: 24px;
}
.el-row {
  width: 100%;
}

.enterprise-status {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 55px;
  .status-title {
    padding: 0;
    width: 100%;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-transform: capitalize;
    text-transform: capitalize;
    color: #353535;
    top: -42px;
    position: relative;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    padding: 20px 0 0 24px;
  }

  .authorization {
    margin-top: 24px;
    // width: 35%;
    background: #fff;
    box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    position: relative;
    padding-bottom: 12px;
    :deep(.el-tooltip__trigger) {
      height: 30px;
      width: auto;
    }
    .chart {
      // margin: 40px 0 0 36%;
      margin: 0 auto;
      margin-top: -20px;
      width: 300px;
      height: 300px;
      // 245, 245, 245
      // background-color: rgb(245, 245, 245);
      // border: 1px solid #000;
      border-radius: 50%;
    }

    .authorization-name {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding: 12px 16px;
      padding: 16px;
      box-sizing: border-box;
      .type {
        display: flex;
        > img {
          width: 24px;
        }
        > span {
          font-size: 18px;
          font-weight: 600;
          line-height: normal;
          color: #000;
          margin: 0 8px;
        }
      }
      .btn-upgrade {
        display: none;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        border: 1px solid rgba(218, 218, 218, 1);
        border-radius: 8px;
        color: rgba(80, 80, 80, 1);
        padding: 6px 18px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .btn-usage {
        padding: 6px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        color: rgba(53, 53, 53, 1);
        border: 1px solid rgba(218, 218, 218, 1);
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        transition: all 0.5s ease;
        cursor: pointer;
        &:hover {
          background: rgba(240, 240, 240, 1);
        }
      }
    }
    .number-container {
      display: flex;
      flex-wrap: wrap;
      padding: 16px;
      box-sizing: border-box;
      min-height: 60px;
      > p {
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        padding: 0;
        width: 50%;
        margin: 5px 0;
        display: flex;
        align-items: center;
        > span {
          background: rgba(80, 80, 80, 1);
          width: 6px;
          height: 6px;
          box-sizing: border-box;
          border-radius: 50%;
          margin: 0 8px;
          display: inline-block;
        }
      }
    }
    .authorization-container {
      background: rgba(251, 251, 251, 1);
      border: 1px solid rgba(0, 0, 0, 0.04);
      margin: 0 16px 0 16px;
      box-sizing: border-box;
      border-radius: 10px;
      display: flex;
      .chart-left {
        flex: 1;
        padding: 0 24px 32px 16px;
        .chart-left-title {
          font-size: 16px;
          padding: 16px 0;
          font-weight: 400;
          text-align: left;
          color: rgba(53, 53, 53, 1);
        }
        .chart-left-content {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 24px;
          padding-bottom: 8px;
          .authorized-span {
            display: block;
            border-radius: 6px;
            width: var(--width);
            background: var(--bgColor);
            height: 20px;
            &.unauthorized {
              margin-left: 4px;
              &.noLeft {
                margin-left: 0;
              }
            }
          }
        }
        .chart-left-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;
          .chart-left-bottom-title {
            flex: 1;
            > span {
              background: var(--bgColor);
              width: 10px;
              height: 10px;
              display: inline-block;
              border-radius: 2px;
              margin-right: 8px;
            }
          }
          .chart-left-bottom-number {
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            color: rgba(138, 138, 138, 1);
            > span {
              color: rgba(53, 53, 53, 1);
            }
          }
        }
      }
      .chart-line {
        margin: 20px 3.5px;
        display: inline-block;
        width: 1px;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.08);
      }
      .chart-right {
        width: 40%;
        position: relative;
        .chart-right-title {
          font-size: 16px;
          padding: 16px;
          font-weight: 400;
          text-align: left;
          color: #353535;
        }
        .chart-container {
          position: relative;
          width: 100%;
          text-align: center;
          padding-bottom: 16px;
          .chart-canvas {
          }
          .chart-text {
            position: absolute;
            transform: translate(-50%, 50%);
            left: 50%;
            bottom: 50%;
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
            text-align: center;
            color: rgba(53, 53, 53, 1);
            > span {
              color: rgba(184, 184, 184, 1);
            }
          }
        }
      }
    }
    &.is-floating-company {
      .authorization-container {
        .chart-right {
          .chart-container {
            .chart-text {
              .text {
                font-size: 14px;
              }
              > span {
                font-size: 12px;
                transform: scale(0.8);
              }
            }
          }
        }
      }
    }
  }

  .totals {
    // width: 26%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .total {
      background: #fff;
      box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.04);
      border-radius: 12px;
      height: 100%;
      > p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        color: rgba(138, 138, 138, 1);
      }
      span {
        display: inline-block;
        margin: 24px 0 16px 24px;
        font-weight: 590;
        font-size: 40px;
        text-transform: capitalize;
      }
      .auth_organize_span {
        font-size: 24px;
      }
    }
  }
}

.quick-entry {
  padding-right: 16px;
  box-sizing: border-box;
  .quick {
    display: flex;
    margin-top: 24px;
    width: 100%;
    background: #fff;
    box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .quick-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 26.06px;
      text-align: left;
      padding: 14px 24px;
    }
    .el-row {
      justify-content: space-around;
    }
    .item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 22.5px 16px;
      transition: all 0.5s;
      border-radius: 12px;
      p {
        text-align: center;
        margin-bottom: 16px;
      }

      span {
        // display: inline-block;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;
        height: 56px;
        width: 56px;
        background: rgba(0, 0, 0, 0);
        > img {
          width: 100%;
        }

        border-radius: 8px;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.06);
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .enterprise-status .totals .total .auth_organize_span {
    font-size: 16px;
  }
}
@media screen and (max-width: 768px) {
  .enterprise-status {
    margin-top: 0;
    .status-title {
      position: sticky;
      z-index: 999;
      top: 0 !important;
      width: 100%;
      height: 59px;
      // height: 109px;
      left: 0px;
      top: 0px;

      background: #353535;

      span {
        position: absolute;

        width: 100%;
        height: 17px;
        top: 23px;
        text-align: center;
        font-family: 'SF Pro';
        font-style: normal;
        font-weight: 590;
        font-size: 14px;
        line-height: 17px;
        height: 17px;

        color: #ffffff;
      }
    }

    .authorization {
      // width: 343px;
      p {
        // font-family: 'SF Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-transform: capitalize;

        /* Updf/dark bg */

        color: #353535;
      }

      .chart {
        width: 229px;
        height: 229px;
        margin-top: -30px;
      }
    }

    .totals {
      padding-top: 12px;
      box-sizing: border-box;
      .total {
        p {
          // font-family: 'SF Pro';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
        }

        span {
          // font-family: 'SF Pro';
          font-style: normal;
          font-weight: 590;
          font-size: 24px;
          line-height: 29px;
        }
      }

      .total2 {
        margin-top: 16px;
      }
    }

    .el-row {
      margin-right: 16px;
      margin-left: 16px;
    }
  }

  .quick-entry {
    padding-bottom: 20px;

    .entry-title {
      // font-family: 'SF Pro';
      font-style: normal;
      font-weight: 590;
      font-size: 18px;
      line-height: 21px;
      text-transform: capitalize;

      /* Updf/dark bg */

      color: #353535;
      margin-left: 24px;
    }

    .quick {
      // width: 100%;
      width: auto;
      margin-left: 16px;
      // display: flex;
      // justify-content: space-evenly;
      flex-direction: column;

      .item {
        cursor: pointer;
        display: flex;
        /* flex-direction: column; */
        /* align-items: center; */
        /* margin: 64px 50px; */
        width: auto;
        margin-top: 24px;
        margin-left: 24px;
        margin-bottom: 0;
        margin-right: 0;
        flex-direction: row;

        &:last-child {
          margin-bottom: 24px;
        }

        span {
          margin-bottom: 0;
          // position: relative;
          // left: 16px;
        }

        p {
          position: relative;
          left: 16px;
          margin-bottom: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 998px) {
  .enterprise-status .authorization .chart {
    width: 229px;
    height: 229px;
    margin-top: 10px;
  }

  .total p {
    padding: 20px 0 0 14px;
  }

  .quick .item {
    margin: 0;
  }

  .chart {
    position: relative !important;
    right: 35px;
  }
}

@media screen and (min-width: 998px) and (max-width: 1100px) {
  .enterprise-status .authorization .chart {
    width: 229px;
    height: 229px;
    margin-top: 10px;
  }

  .total p {
    padding: 20px 0 0 14px;
  }

  .quick .item {
    margin: 0;
  }

  .chart {
    position: relative !important;
    right: 35px;
  }
}

@media screen and (max-width: 500px) {
  :deep(.el-popper) {
    max-width: 300px;
  }
  .enterprise-status {
    .el-row {
      .el-col {
        .authorization {
          .authorization-container {
            flex-wrap: wrap;
            .chart-left {
              flex: none;
              width: 100%;
              box-sizing: border-box;
              padding: 0 24px 0px 16px;
            }
            .chart-right {
              width: 100%;
            }
          }
        }
      }
    }
    .authorization {
      .authorization-name {
        flex-wrap: wrap;
        .btn-usage {
          margin: 8px auto 0;
        }
      }
      .number-container {
        > p {
          width: 100%;
        }
      }
    }
  }
}
.ar-SA {
  .enterprise-status .authorization {
    padding-right: 20px;
  }
  .enterprise-status .totals .total {
    padding-right: 20px;
  }
  .quick-entry .entry-title {
    padding-right: 20px;
  }
  .quick-entry .quick .item {
    gap: 10px;
  }
}
</style>

<style>
@media screen and (max-width: 500px) {
  .el-popper {
    max-width: 300px;
  }
}
</style>
